export default "__VITE_ASSET__B0Z$6I1J__"